<script setup>
import { useSettingsStore } from '@stores/settings';
import { useFavoriteGameStore } from '@/stores/favorite-games';
import { useAuthStore } from '@stores/auth';

const settingsStore = useSettingsStore();
const authStore = useAuthStore();
const favoriteGameStore = useFavoriteGameStore();
const settings = settingsStore.settings;

</script>

<template>
  <div class="flex select-none flex-col gap-4 sm:gap-6 min-w-full max-w-full">
    <CircleMenu />
    <Search />
  
    <TermsModal v-if="authStore.isLoggedIn" />

    <Favorite v-if="authStore.user && favoriteGameStore.favorites.length > 0" />
    <Categories />

    <LegitimuzElements />

    <div v-if="!settings.casino_enabled" class="flex">
      <h2 class="mx-auto mt-5 text-lg font-bold">Casino em manutenção</h2>
    </div>

    <Promotions />
    <ProviderCarousel />
  </div>
</template>